import { useEffect } from 'react';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useReducedMotion from '../../hooks/useReducedMotion';

gsap.registerPlugin(ScrollTrigger);

const DESKTOP_MQ = '(min-width: 981px) and (hover: hover) and (pointer: fine)';

/**
 * Smooth scroll Lenis — desktop uniquement, désactivé si reduced-motion.
 * Synchronisé avec GSAP ScrollTrigger (parallaxe hero).
 */
const SmoothScroll = () => {
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    if (reducedMotion || !window.matchMedia(DESKTOP_MQ).matches) return undefined;

    const lenis = new Lenis({
      duration: 1.05,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      anchors: false,
    });

    lenis.on('scroll', ScrollTrigger.update);
    window.__lenis = lenis;

    const raf = (time) => {
      lenis.raf(time * 1000);
    };
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      if (window.__lenis === lenis) {
        delete window.__lenis;
      }
    };
  }, [reducedMotion]);

  return null;
};

export default SmoothScroll;
